import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'aid-infinite-scroll',
  template: `
    <div
      class="overflow full-height aid-layout-column"
      infinite-scroll
      [infiniteScrollDistance]="2"
      [infiniteScrollUpDistance]="1000"
      [infiniteScrollThrottle]="300"
      [scrollWindow]="false"
      (scrolled)="onScroll()"
    >
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./infinite-scroll.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InfiniteScrollComponent implements OnInit {
  @Output() scroll = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  onScroll() {
    this.scroll.emit();
  }
}
